import { lazy } from 'react';

const VerificationDrawerModal = lazy(() =>
  import('./components/modals/VerificationDrawerModal'),
);

const DeclineStudentIndicatorUploadModal = lazy(() =>
  import('./components/modals/DeclineConfirm'),
);

export default {
  INDICATOR_VERIFICATION_DRAWER_MODAL: VerificationDrawerModal,
  DECLINE_STUDENT_INDICATOR_UPLOAD_MODAL: DeclineStudentIndicatorUploadModal,
};
